// CMS API Client for Skatunderlup

// Base fetch helper: uses relative /_api on same origin (rule 11b), with fallback to platform endpoint
async function apiFetch(endpointPath) {
  try {
    const res = await fetch(`/_api${endpointPath}`);
    if (res.ok) return res;
  } catch {
    // Relative fetch failed, fall through to absolute dev endpoint
  }
  return fetch(`https://api.dev.auxo.dk${endpointPath}`);
}

export function getItemSlug(item) {
  if (!item) return '';
  if (typeof item.slug === 'string') return item.slug;
  if (item.slug && typeof item.slug === 'object') {
    return item.slug._ || item.slug.da || Object.values(item.slug)[0] || '';
  }
  return item.id || '';
}

export async function fetchCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    if (params.limit) query.set("limit", params.limit);
    if (params.offset) query.set("offset", params.offset);
    if (params.sort) query.set("sort", params.sort);
    if (params.order) query.set("order", params.order);
    if (params.term) {
      if (Array.isArray(params.term)) {
        params.term.forEach((t) => query.append("term", t));
      } else {
        query.set("term", params.term);
      }
    }
    // Any extra equality filters
    Object.entries(params).forEach(([k, v]) => {
      if (!["limit", "offset", "sort", "order", "term"].includes(k) && v !== undefined && v !== null && v !== "") {
        query.set(k, v);
      }
    });

    const queryString = query.toString();
    const endpoint = `/public/v2/content/${collectionName}${queryString ? `?${queryString}` : ""}`;
    const res = await apiFetch(endpoint);
    if (!res.ok) {
      throw new Error(`Failed to fetch ${collectionName}: ${res.statusText}`);
    }
    const data = await res.json();
    return data; // { items: [...], total, limit, offset }
  } catch (err) {
    console.warn(`[CMS] Error fetching ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

export async function fetchBySlug(slug) {
  try {
    const res = await apiFetch(`/public/by-slug/${slug}`);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.warn(`[CMS] Error fetching slug ${slug}:`, err);
    return null;
  }
}

export async function fetchSingleEntry(collectionName, entryId) {
  try {
    const res = await apiFetch(`/public/content/${collectionName}/${entryId}`);
    if (!res.ok) {
      return null;
    }
    return await res.json();
  } catch (err) {
    console.warn(`[CMS] Error fetching entry ${entryId}:`, err);
    return null;
  }
}

// Cloudflare Image Resizing helper per project rule 9
export function optimizeImage(url, options = { width: 800, quality: 80 }) {
  if (!url || typeof url !== "string") return "";
  if (!url.startsWith("https://assets.auxodev.dk/")) return url;
  if (url.includes("/cdn-cgi/image/")) return url;

  const width = options.width || 800;
  const quality = options.quality || 80;
  const fit = options.height ? `,height=${options.height},fit=cover` : "";
  const transform = `width=${width},quality=${quality},format=auto${fit}`;

  return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/${transform}/`);
}
